import React from 'react'
import { SVGIcon } from '~/utils/types'

const TOTAL_BARS = 5
const BARS_COLORS = {
  green: '#80B13D',
  blue: '#2c8ccd',
  red: '#c94350',
  grey: '#D2D2D2',
}

interface BarChartProps extends SVGIcon {
  barCount: number
  color: keyof typeof BARS_COLORS
}

export const BarChart = ({ barCount, color, ...props }: BarChartProps) => {
  const coloredBarColor = BARS_COLORS[color] || BARS_COLORS.grey

  const bars = new Array(TOTAL_BARS).fill(BARS_COLORS.grey)

  for (let i = 0; i < barCount; i++) {
    bars[i] = coloredBarColor
  }

  const maxHeight = 40
  const heightIncrement = 8

  return (
    <svg
      width="80"
      height={maxHeight}
      viewBox={`0 0 80 ${maxHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        {bars.map((fillColor, index) => {
          const height = (index + 1) * heightIncrement
          return (
            <rect
              key={index}
              fill={fillColor}
              x={14 * index}
              y={maxHeight - height}
              width="10"
              height={height}
              rx="1"
            />
          )
        })}
      </g>
    </svg>
  )
}
